import React from 'react';
export const IntroductionSection = () => {
  return <section className="w-full bg-white px-5 py-10" data-id="element-152">
      <div className="max-w-md mx-auto" data-id="element-153">
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-154">
          "What you're feeling isn't just 'aging'," my gynecologist said, her
          voice full of warmth.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-155">
          "It's a condition called Atrophic Vaginitis, but I prefer to call it
          an <strong data-id="element-156">internal moisture deficit.</strong> Most doctors just
          recommend a lubricant and send you on your way. They're taught to
          treat the symptom, not rebuild the system."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-157">
          She pulled her chair closer, the sound grounding me in the quiet of
          the exam room.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-158">
          "Let me show you what's really happening inside."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-159">
          She sketched out a simple flowchart.
        </p>
        <div className="bg-pink-50 border border-pink-100 rounded-xl p-5 mb-7 shadow-sm" data-id="element-160">
          <div className="flex flex-col items-center" data-id="element-161">
            <div className="bg-white rounded-xl p-4 mb-4 w-full shadow-sm" data-id="element-162">
              <p className="text-base text-gray-800 leading-relaxed" data-id="element-163">
                <span className="font-bold" data-id="element-164">Stage 1:</span> Hormonal shifts
                (perimenopause, postpartum, stress) signal a slowdown in
                moisture production.
              </p>
            </div>
            <div className="h-10 w-1 bg-pink-300" data-id="element-165"></div>
            <div className="bg-white rounded-xl p-4 mb-4 w-full shadow-sm" data-id="element-166">
              <p className="text-base text-gray-800 leading-relaxed" data-id="element-167">
                <span className="font-bold" data-id="element-168">Stage 2:</span> Vaginal walls begin
                to thin. Cellular hydration plummets, causing friction and
                irritation.
              </p>
            </div>
            <div className="h-10 w-1 bg-pink-300" data-id="element-169"></div>
            <div className="bg-white rounded-xl p-4 mb-4 w-full shadow-sm" data-id="element-170">
              <p className="text-base text-gray-800 leading-relaxed" data-id="element-171">
                <span className="font-bold" data-id="element-172">Stage 3:</span> The delicate
                microbiome weakens. pH is disrupted, leaving you vulnerable and
                uncomfortable.
              </p>
            </div>
            <div className="h-10 w-1 bg-pink-300" data-id="element-173"></div>
            <div className="bg-white rounded-xl p-4 w-full shadow-sm" data-id="element-174">
              <p className="text-base text-gray-800 font-semibold leading-relaxed" data-id="element-175">
                Causing painful intimacy, constant irritation, and loss of
                confidence.
              </p>
            </div>
          </div>
        </div>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-176">
          "First, as our hormones shift, our body's natural signal to produce
          moisture gets weaker."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-177">
          "Second, the vaginal tissue itself becomes thinner and less elastic.
          Think of it like a grape turning into a raisin. It loses its plumpness
          and resilience."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-178">
          "Third, and this is the part almost everyone misses – this dry
          environment weakens your protective microbiome, disrupting your pH and
          leaving the tissue irritated and vulnerable."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-179">
          "Wait," I said, my voice barely a whisper. "So lubricants are just...
          a temporary fix? They're not actually solving anything?"
        </p>
        <p className="text-gray-700 font-bold text-lg mb-7 leading-relaxed" data-id="element-180">
          "Exactly!" She gave a knowing nod. "You're not fighting dryness.
          You're fighting a total collapse of your body's internal hydration
          system."
        </p>
        <div className="border-b border-gray-200 w-full mb-7" data-id="element-181"></div>
        <div className="mb-7" data-id="element-182">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mmdyz4TTd3uEnhVkYQcbTt/HEALTHY_VS_UNHEALTHY_VAGINA.png" alt="Comparison between healthy vagina with beneficial bacteria and unhealthy vagina with harmful bacteria" className="w-full h-auto rounded-xl shadow-sm" data-id="element-183" />
        </div>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-184">
          Tears pricked my eyes.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-185">
          Years of painful intimacy. Years of feeling broken and blaming myself.
          Years of my partner trying to be understanding, but the distance
          between us growing with every "not tonight."
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-186">
          Meanwhile, his doctor had a prescription for him in five minutes.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-187">
          But for my very real, daily discomfort? I was told it was "normal" and
          handed a sample of sticky, cold lubricant.
        </p>
        <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-188">
          "So what's the solution?" I asked, desperate.
        </p>
        <div className="border-b border-gray-200 w-full mb-7" data-id="element-189"></div>
        <h2 className="text-2xl font-bold text-pink-900 mb-7 leading-tight" data-id="element-190">
          Here's how Nuora rebuilds your entire intimate ecosystem from the
          inside out – and delivers life-changing results:
        </h2>
      </div>
    </section>;
};